import { TransportationPayment } from "@/features/transportations/transportation-payment.type";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { Price, StoredObject } from "@/features/types";

export interface UpdateTransportationPaymentParameter {
  agencyId: number;
  transportationId: number;
  paymentId: number;
}

export interface UpdateTransportationPaymentRequest {
  issuedOn: Date;
  file: Pick<StoredObject, "id" | "name"> | null;
  amount: Price;
  isRemitted: boolean;
  remittedOn: Date | null;
}

export interface UpdateTransportationPaymentResponse extends TransportationPayment {}

const templateUrl = `/agencies/:agencyId/transportations/:transportationId/transportation-payments/:paymentId`;

export const updateTransportationPaymentKey: YWRKey<UpdateTransportationPaymentParameter> = {
  url: (parameter) => calcUrl(templateUrl, parameter),
  method: "put",
};

export default function useUpdateTransportationPayment() {
  const fetcher = useFetcher<
    UpdateTransportationPaymentRequest,
    UpdateTransportationPaymentResponse
  >();
  return useYWR(updateTransportationPaymentKey, fetcher);
}
